import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

interface BackLinkProps {
    to: string;
    label: string;
}

export function BackLink({ to, label }: BackLinkProps) {
    return (
        <div className="text-center">
            <Link
                to={to}
                className="inline-flex items-center gap-2 text-primary hover:text-primary/80 transition-colors"
            >
                <ChevronLeft className="w-4 h-4" />
                {label}
            </Link>
        </div>
    );
}
